import { useMemo } from 'react';
export var BgType;
(function (BgType) {
  /**
   * 图片背景
   */
  BgType["BG_PICTURE"] = "bgPicture";
  /**
   * 颜色背景
   */
  BgType["BG_COLOR"] = "bgColor";
})(BgType || (BgType = {}));
export var useWrapStyle = function useWrapStyle(bgSetting, bgPicture, bgColor) {
  return useMemo(function () {
    if (bgSetting === BgType.BG_PICTURE && bgPicture) {
      return {
        backgroundImage: "url(".concat(bgPicture.path, ")"),
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 200px'
      };
    } else {
      return {
        background: bgColor
      };
    }
  }, [bgSetting, bgPicture, bgColor]);
};